module.exports = __webpack_public_path__ + "static/media/YF70_0.7c5826a6.jpg";